@let vs = presenter.viewState();
@let assetName = asset();

<spa-button
  [ariaLabel]="vs.ariaLabel"
  [asset]="assetName"
  [disabled]="vs.disabled"
  [display]="vs.display"
  [icon]="assetName ? '' : vs.icon"
  [iconPlacement]="vs.isTrailing ? 'icon-after' : 'icon-before'"
  [shape]="shapeFor(vs.variant)"
  [type]="vs.type === 'submit' ? 'submit' : 'button'"
  (clickedButton)="presenter.onClick($event)"
/>
